import {
  Box,
  FormLabel,
  Grid,
  Stack,
  Typography,
  CircularProgress
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { CommonButton } from "../common/commonButton";
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import { useEffect, useState } from "react";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { CommonPaginationContainer, CommonSelect } from "../common";
import { getPaginationCount } from "../CashAllocation/utils";
import { GetEmailList, SendEmail } from "../../Services/api";
import instance from "../../redux/api";
import { toast } from "react-toastify";

export default function EmailContainer() {
  const toggle = useSelector((state) => state.toggleSideMenu);
  const emailContainer = {
    width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
    height: "525px",
  };

  const headerText = {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "400",
    marginTop: 5,
  };

  const classes = useStyles();

  //For Date picker
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isEmailOpen, setIsEmailOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isReplyEnable, setIsReplyEnable] = useState(false);
  const [emailReply, setEmailReply] = useState(null);
  const [isSendingEmailReply, setIsSendingEmailReply] = useState(false);

  const isFilterBtnDisable = () => {
    let disabled = true;
    if (
      fromDateValue !== "" ||
      toDateValue !== ""
    ) {
      disabled = false;
    }
    return disabled;
  };

  // const handleEnter = (e) => {
  //   if (e.code === "Enter") {
  //     handleSearchEmailList();
  //   }
  // };

  const handleClearSearchEmailList = async () => {
    setIsClearPerformed(true);
    setFromDateValue("");
    setToDateValue("");
  };

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize
        }`;

      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      }

      const response = await instance.get(
        `${GetEmailList}?${queryParams}`
      );

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      handleVarianceResponse(response);

    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const handleVarianceResponse = (response) => {
    if (response.status === 200) {
      setPageState((old) => ({ ...old, total: response?.data?.count, data: response.data.data || [] }));
    }
    else {
      setPageState((old) => ({ ...old, total: response?.data?.count, data: [] }));
      setPaginationCount(0);
    }
  };

  useEffect(() => {
    loadData();
  }, [pageState?.pageSize, pageState?.page])

  const searchQueryParams = () => {
    return {
      fromDate: fromDateValue,
      toDate: toDateValue,
    };
  };

  const openEmail = (() => {
    console.log("selectedEmail", selectedEmail)
  })

  useEffect(() => {
    openEmail();
  }, [selectedEmail])

  const handleBackClick = () => {
    if (isReplyEnable) {
      setIsReplyEnable(false);
    } else {
      setSelectedEmail(null);
    }
  };

  const HandleReplyClick = () => {
    setIsReplyEnable(true);
  };

  const handleReplyChange = (reply) => {
    console.log("reply", reply)
    setEmailReply(reply);
  }

  const HandleSendClick = async () => {
    setIsSendingEmailReply(true);
    try {
      console.log("emailReply", emailReply)
      const payload = selectedEmail;
      payload.reply = emailReply
      let response = await instance.post(SendEmail, payload);
      console.log("response", response)
      if (response?.status === 200) {
        toast.success("Email send successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });

        setIsReplyEnable(false);
      }
    } catch (error) {
      console.error("Error saving changes:", error);
      toast.error("Failed to save changes", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    } finally {
      setIsSendingEmailReply(false);
    }
  }

  const columns = [
    {
      field: "from",
      headerName: "From",
      align: "left",
      headerAlign: "left",
      width: 350,
      valueGetter: (params) => params?.row?.from,
      renderCell: (params) => (
        <span style={{ color: "#666", paddingLeft: "5px", fontSize: "17px" }}>{params?.row?.from}</span>
      ),
    },
    {
      field: "subject",
      headerName: "Subject",
      align: "left",
      headerAlign: "left",
      width: 800,
      valueGetter: (params) => params?.row?.subject,
      renderCell: (params) => (
        <a
          href={`javascript:void(0)`}
          onClick={() => {
            setIsEmailOpen(true)
            setSelectedEmail(params?.row)
          }
          }
          rel="noopener noreferrer"
          role="button"
          style={{
            color: "blue",
            textAlign: "left",
            textDecoration: "none",
            alignItems: "center",
            width: "100%",
            paddingLeft: "5px",
            fontSize: "17px"
          }}
        >
          <span style={{ color: "blue" }}>{params?.row?.subject}</span>
        </a>
      ),
    },
    {
      field: "date",
      headerName: "Date",
      align: "left",
      headerAlign: "left",
      width: 150,
      valueGetter: (params) => params?.row?.date,
      renderCell: (params) => (
        <span style={{ color: "#666", paddingLeft: "5px", fontSize: "17px" }}>{params?.row?.date}</span>
      ),
    }
  ];

  return (
    <Box style={emailContainer}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={headerText}>
          <Typography
            variant="h3"
            style={{
              color: "#FF5A01",
              fontSize: "24px",
              margin: "10px 0px 15px 0px",
            }}
          >
            Email
          </Typography>
        </div>
        {selectedEmail && <Grid>
          <Grid item paddingTop={'15px'}>
            <CommonButton
              text="Back"
              hoverColor="#EE3F00"
              handleClick={handleBackClick}
            />
          </Grid>
        </Grid>}
      </div>

      {selectedEmail ? (
        isReplyEnable ? (
          <Grid>
            {console.log("isReplyEnable 1", isReplyEnable)}
            <Grid
              sx={{
                borderBottom: '1px solid #DEDEDE'
              }}
            >
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: "10px",
                }}
                xs={12}
                gap={"10px"}
              >
                <Grid sx={{
                  display: "flex",
                  flexDirection: "column"
                }}
                >
                  <Typography
                    style={{
                      fontSize: "18px"
                    }}
                  >
                    From : {selectedEmail?.to} (me)
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "18px"
                    }}
                  >
                    To : {selectedEmail?.from}
                  </Typography>
                </Grid>
                <Grid item>
                  {isSendingEmailReply ?
                    <CircularProgress size={35} style={{ color: "rgb(255, 90, 1)" }} />
                    :
                    <CommonButton
                      text="Send"
                      hoverColor="#EE3F00"
                      handleClick={HandleSendClick}
                    />
                  }
                </Grid>
              </Grid>
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: "10px",
                }}
                xs={12}
                gap={"10px"}
              >
                <Typography
                  style={{
                    fontSize: "20px"
                  }}
                >
                  Re : {selectedEmail?.subject}
                </Typography>
                <Typography
                  style={{
                    fontSize: "18px"
                  }}
                >
                  Datetime : {selectedEmail?.date}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 343px)",
              }}
            >
              <textarea
                style={{
                  width: "99%",
                  height: "100%",
                  padding: "10px",
                  border: "none",
                  outline: "none",
                  resize: "none",
                  fontSize: "16px",
                  fontFamily: "Arial, sans-serif",
                  lineHeight: "1.5",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "6px",
                  boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                }}
                onChange={(e) => handleReplyChange(e.target.value)}
              >
              </textarea>
            </Grid>
          </Grid>
        ) : (
          <Grid>
            {console.log("isReplyEnable 2", isReplyEnable)}
            <Grid
              sx={{
                borderBottom: '1px solid #DEDEDE'
              }}
            >
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: "10px",
                }}
                xs={12}
                gap={"10px"}
              >
                <Typography
                  style={{
                    fontSize: "20px"
                  }}
                >
                  Subject : {selectedEmail?.subject}
                </Typography>
                <Grid item>
                  <CommonButton
                    text="Reply"
                    hoverColor="#EE3F00"
                    handleClick={HandleReplyClick}
                  />
                </Grid>
              </Grid>
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: "10px",
                }}
                xs={12}
                gap={"10px"}
              >
                <Grid sx={{
                  display: "flex",
                  flexDirection: "column"
                }}
                >
                  <Typography
                    style={{
                      fontSize: "18px"
                    }}
                  >
                    From : {selectedEmail?.from}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "18px"
                    }}
                  >
                    To : {selectedEmail?.to} (me)
                  </Typography>
                </Grid>
                <Typography
                  style={{
                    fontSize: "18px"
                  }}
                >
                  Datetime : {selectedEmail?.date}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              sx={{
                paddingTop: "10px"
              }}
            >
              {selectedEmail?.body}
            </Grid>
          </Grid>
        )
      ) : (
        <>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              mb: "10px",
            }}
            xs={12}
            gap={"10px"}
          >
            <Grid
              item
              display={"flex"}
              flexDirection={"column"}
              gap={"4px"}
              xs={2.5}
            >
              <FormLabel>Email Period</FormLabel>
              <CustomDateRangePicker
                startDate={fromDateValue}
                setStartDate={setFromDateValue}
                endDate={toDateValue}
                setEndDate={setToDateValue}
                maxDate={new Date()}
              />
            </Grid>
            <Grid item alignSelf={"flex-end"}>
              <CommonButton
                text="Search"
                // handleClick={handleSearchEmailList}
                hoverColor="#EE3F00"
                disabled={pageState?.isLoading || isFilterBtnDisable()}
              />
            </Grid>
            <Grid item xs={1.5} alignSelf={"flex-end"}>
              <CommonButton
                text="Clear"
                handleClick={handleClearSearchEmailList}
                hoverColor="#EE3F00"
                disabled={pageState?.isLoading || isFilterBtnDisable()}
              />
            </Grid>
          </Grid>
          <div
            style={{
              height: "calc(100vh - 313px)",
              position: "relative",
              display: "flex",
              flexDirection: "row-reverse",
            }}
          >
            <DataGrid
              className={classes.pagination}
              loading={pageState?.isLoading}
              rows={pageState?.data ?? []}
              columns={columns}
              rowCount={pageState?.total}
              keepNonExistentRowsSelected
              disableSelectionOnClick
              pagination
              paginationMode="server"
              // getRowId={(row) => row?.subject}
              page={pageState.page - 1}
              pageSize={pageState?.pageSize ?? 25}
              rowsPerPageOptions={[10, 25, 50, 100]}
              onPageSizeChange={(newPageSize) => {
                return setPageState((old) => {
                  setPaginationCount(getPaginationCount(pageState?.total, newPageSize))
                  return { ...old, pageSize: newPageSize, page: 1 };
                });
              }}
              sx={{
                "& .MuiDataGrid-row .MuiDataGrid-cell": {
                  justifyContent: "flex-start !important",
                  textAlign: "left",
                },
                "& .MuiDataGrid-row .MuiDataGrid-cell .MuiDataGrid-cellContent": {
                  textAlign: "left",
                },
              }}
            />
            <Stack
              style={{
                position: "absolute",
                bottom: "8px",
              }}
            >
              <CommonPaginationContainer
                count={paginationCount + 1}
                pageState={pageState}
                setPageState={setPageState}
              />
            </Stack>
          </div>
        </>
      )}
    </Box >
  );
}
